import { formatPrice } from '../formatting';
import getSubscriptionIntervalWithSlash from '../formatting/getSubscriptionIntervalWithSlash';

export default function getProductPriceLabel(product, locale, options = { short: false }) {
  const formattedPrice = formatPrice({
    amount: product.price,
    currency: product.currency,
    locale,
    style: 'currency',
  });

  if (product.type === 'subscription') {
    if (product.price > 0) {
      return `${formattedPrice} ${getSubscriptionIntervalWithSlash(
        product.interval,
        product.intervalCount,
        product,
      )}`;
    } else {
      return ``;
    }
  }

  if (product.payWhatYouWant) {
    if (product.price > 0) {
      return options.short ? `PWYW (${formattedPrice}+)` : `Pay what you want (${formattedPrice}+)`;
    }

    return `Pay what you want`;
  }

  if (product.price > 0) {
    return `${formattedPrice}`;
  } else {
    return ``;
  }
}
